import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getSafeExternalHttpUrl(value) {
  const trimmed = typeof value === 'string' ? value.trim() : '';
  if (!trimmed) return '';

  try {
    const parsed = new URL(trimmed);
    return ['http:', 'https:'].includes(parsed.protocol) ? parsed.toString() : '';
  } catch {
    return '';
  }
}

function hasProtocol(value) {
  return /^[a-z][a-z\d+\-.]*:\/\//i.test(value);
}

export function normalizeExternalUrl(type, value) {
  const trimmed = value?.trim();
  if (!trimmed) return '';

  if (trimmed.startsWith('/') || trimmed.startsWith('?') || trimmed.startsWith('#')) {
    return trimmed;
  }

  if (hasProtocol(trimmed)) return trimmed;

  if (trimmed.startsWith('//')) {
    return `https:${trimmed}`;
  }

  if (type === 'instagram') {
    return `https://instagram.com/${trimmed.replace(/^@+/, '')}`;
  }

  if (type === 'tiktok') {
    if (trimmed.startsWith('@')) return `https://tiktok.com/${trimmed}`;
    return `https://tiktok.com/@${trimmed.replace(/^@+/, '')}`;
  }

  if (type === 'youtube') {
    if (trimmed.startsWith('@')) return `https://youtube.com/${trimmed}`;
    if (/^UC[\w-]+$/.test(trimmed)) return `https://www.youtube.com/channel/${trimmed}`;
    return `https://${trimmed}`;
  }

  if (type === 'spotify') {
    if (trimmed.startsWith('spotify:artist:')) {
      const artistId = trimmed.split(':')[2];
      return artistId ? `https://open.spotify.com/artist/${artistId}` : '';
    }
    return `https://${trimmed}`;
  }

  return `https://${trimmed}`;
}
